import React, { useState, useEffect } from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Amit Verma",
      image: "https://inframantra.blr1.cdn.digitaloceanspaces.com/testimonials/deepikagrover/client1.png", // Replace with your actual image paths
      text: "Working with INFRAMANTRA was an absolute pleasure. Their expertise and dedication made the process of buying my first home a breeze.",
    },
    {
      id: 2,
      name: "Deepika Grover",
      image: "https://inframantra.blr1.cdn.digitaloceanspaces.com/testimonials/deepikagrover/client1.png",
      text: "The process was quite clear from the start, with every step explained in detail, making home buying hassle-free. INFRAMANTRA ensured transparency.",
    },
    {
      id: 3,
      name: "Alka Sharma",
      image: "https://inframantra.blr1.cdn.digitaloceanspaces.com/testimonials/deepikagrover/client1.png",
      text: "Their professionalism, deep market knowledge, and exceptional service made the entire home-buying process smooth and stress-free.",
    },
    {
      id: 4,
      name: "Manish Himthani",
      image: "https://inframantra.blr1.cdn.digitaloceanspaces.com/testimonials/deepikagrover/client1.png",
      text: "The team at INFRAMANTRA really listened to my needs and preferences. They showed me properties that matched exactly what I was looking for.",
    }
  ];

  // For infinite loop, we duplicate the list
  const displayList = [...testimonials, ...testimonials];

  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <h1>Trusted by Homebuyers</h1>
        <p>Real experiences from people who found their dream homes with us.</p>
      </div>

      <div className="slider-container">
        <div className="slider-trackk">
          {displayList.map((item, index) => (
            <div className="testimonial-card" key={index}>
              <div className="profile-img-container">
                <img src={item.image} alt={item.name} className="profile-img" />
              </div>
              <div className="card-content">
                <div className="stars">★★★★★</div>
                <h3 className="user-name">{item.name}</h3>
                <span className="quote-icon">“</span>
                <p className="testimonial-text">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button className="read-more-btn">Read More</button>
    </section>
  );
};

export default Testimonials;